import { customHeader } from "./custom-header";

const initHeader = () => {
  $(".site-name").parent("div").addClass("site-name-wrapper");

  $(".top-nav-button-login").prependTo(".navigation-buttons");
  $(".responsive-tools").prependTo(".navigation-buttons");

  $("#navigation li.ext").on({
    mouseenter: function () {
      if ($(window).width() > 1200) {
        var submenu = $(this).find(".menu-level-2");
        var submenuWidth = submenu.width();
        var submenuParentWidth = submenu.parent().width();
        var offset = submenu.offset();
        var navigation = $("#navigation").width();
        var parentOffset = submenu.parent().position();

        offset.left = offset.left + parentOffset.left;
        var isTooWide = offset.left + submenuWidth;

        if (isTooWide > navigation && offset.left + submenuParentWidth > submenuWidth) {
          $(submenu).css("left", offset.left - submenuWidth + submenuParentWidth);
        } else {
          $(submenu).css("left", "auto");
        }
      }
    },
    mouseleave: function () {
      if ($(window).width() > 1200) {
        $(".menu-level-2").css("left", "auto");
      }
    },
  });

  const header = $(".header-top");
  if (header) {
    $(customHeader).insertAfter(header);
    const page = document.location.pathname.replace(/\//g, "");

    if (page === "o-nas") {
      $(".custom-header__item").removeClass("active");
      $(".custom-header__item.about").addClass("active");
    }
    if (page === "kola-na-zakazku") {
      $(".custom-header__item").removeClass("active");
      $(".custom-header__item.bikes").addClass("active");
    }
    if (page === "servis") {
      $(".custom-header__item").removeClass("active");
      $(".custom-header__item.servis").addClass("active");
    }
    if (page === "test-centrum") {
      $(".custom-header__item").removeClass("active");
      $(".custom-header__item.test").addClass("active");
    }
    if (page === "kontakt") {
      $(".custom-header__item").removeClass("active");
      $(".custom-header__item.contact").addClass("active");
    }
  }
};

export { initHeader };
